export const PAYMENT_METHOD_STRIPE = 'stripe'
export const PAYMENT_METHOD_CASH = 'cash'
export const PAYMENT_METHOD_PAYPAL = 'Paypal'
export const PAYMENT_METHOD_BRAINTREE = 'Braintree'
export const PAYMENT_METHOD_AFTERPAY = 'Afterpay'
export const PAYMENT_METHOD_SPOONDOLLARS = 'spoondollars'
export const PAYMENT_METHOD_PURCHASE_ORDER = 'PurchaseOrder'
export const STRIPE_KEY = process.env.NEXT_PUBLIC_STRIPE_KEY || ''
